var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"activity-overlay"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showActivity),expression:"showActivity"}],staticClass:"overlay-bg"},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._v(" "),_c('pulse-loader',{attrs:{"loading":_vm.showActivity,"color":"#56b100"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd3b1be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/shared/components/ActivityOverlay.vue
// module id = 77
// module chunks = 0 1 3 4